import moment from "moment";

// 基本クラス Point
class Model {
  constructor() {
    this._deletedFlag;
    this._version;
    this._resourceId;
    this._createdAt;
    this._createdBy;
    this._updatedAt;
    this._updatedBy;
    this._deletedAt;
    this._deletedBy;
  }

  get deletedFlag() {
    return this._deletedFlag;
  }

  set deletedFlag(value) {
    this._deletedFlag = value;
  }

  get version() {
    return this._version;
  }

  set version(value) {
    this._version = value;
  }

  get resourceId() {
    return this._resourceId;
  }

  set resourceId(value) {
    this._resourceId = value;
  }

  get createdAt() {
    return this._createdAt;
  }

  set createdAt(value) {
    this._createdAt = value;
  }

  get createdBy() {
    return this._createdBy;
  }

  set createdBy(value) {
    this._createdBy = value;
  }

  get updatedAt() {
    return this._updatedAt;
  }

  set updatedAt(value) {
    this._updatedAt = value;
  }

  get updatedBy() {
    return this._updatedBy;
  }

  set updatedBy(value) {
    this._updatedBy = value;
  }

  get deletedAt() {
    return this._deletedAt;
  }

  set deletedAt(value) {
    this._deletedAt = value;
  }

  get deletedBy() {
    return this._deletedBy;
  }

  set deletedBy(value) {
    this._deletedBy = value;
  }

  json() {
    return {
      deletedFlag: this.deletedFlag,
      version: this.version,
      resourceId: this.resourceId,
      createdAt: this.createdAt,
      createdBy: this.createdBy,
      updatedAt: this.updatedAt,
      updatedBy: this.updatedBy,
      deletedAt: this.deletedAt,
      deletedBy: this.deletedBy,
    };
  }

  copyProperties(obj) {
    this.deletedFlag = obj.deletedFlag;
    this.version = obj.version;
    this.resourceId = obj.resourceId;
    this.createdAt = obj.createdAt;
    this.createdBy = obj.createdBy;
    this.updatedAt = obj.updatedAt;
    this.updatedBy = obj.updatedBy;
    this.deletedAt = obj.deletedAt;
    this.deletedBy = obj.deletedBy;
  }

  getApiRequestJson() {
    const json = {
      deleted_flag: this.deletedFlag,
      version: this.version,
      resource_id: this.resourceId,
      created_at: this.createdAt,
      created_by: this.createdBy,
      updated_at: this.updatedAt,
      updated_by: this.updatedBy,
      deleted_at: this.deletedAt,
      deleted_by: this.deletedBy,
    };
    return json;
  }

  setApiResponseJosn(item) {
    this.deletedFlag = item.deleted_flag;
    this.version = item.version;
    this.resourceId = item.resource_id;
    this.createdAt = item.created_at;
    this.createdBy = item.created_by;
    this.updatedAt = item.updated_at;
    this.updatedBy = item.updated_by;
    this.deletedAt = item.deleted_at;
    this.deletedBy = item.deleted_by;
  }

  static getDateText(iso8601Text, format = "YYYY/MM/DD") {
    return moment(Date.parse(iso8601Text)).format(format);
  }
}

export default Model;
